module.exports = __webpack_public_path__ + "a59cbaa3.png";